module.exports = "<div class=\"margin-md padding-md text-light\">\r\n\t<b>Elige un Empleado</b>\r\n</div>\r\n<div ng-repeat=\"item in $ctrl.data\">\r\n\t<finanzas-empleadoprestamos-lista-item\r\n\t\tdata=\"item\"\r\n\t\tseleccionar-empleado=\"$ctrl.seleccionar($event.data)\"\r\n\t></finanzas-empleadoprestamos-lista-item>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/_/empleadoprestamos/components/lista/template.html
// module id = 2958
// module chunks = 0